import { reportCircleView } from './circle'
import { reportProgramView } from './program'
import { reportVideoLiveView } from './video-live'
import { reportRevealView, reportRevealProgramView, reportRevealScheduleView } from './reveal'
import { reportHotTopicComment, reportHotTopicCreateNote, reportHotTopicView } from './hot-topic'
import { reportNewsComment, reportNewsCreateNote, reportNewsPraise, reportNewsShare, reportNewsView } from './news'
import { reportActMixView } from './act-mix'
import { reportAskdView, reportAskdNote, reportAskdViewCase } from './askd'
import { reportCsrView, reportCsrNote, reportCsrViewCase } from './csr'

export const sensorsKBPGCUserAct = {
    reportActMixView,
    
    reportCircleView,

    reportProgramView,

    reportRevealView,
    reportRevealProgramView,
    reportRevealScheduleView,

    reportVideoLiveView,

    reportNewsComment,
    reportNewsCreateNote,
    reportNewsPraise,
    reportNewsShare,
    reportNewsView,

    reportHotTopicComment,
    reportHotTopicCreateNote,
    reportHotTopicView,

    reportAskdView,
    reportAskdNote,
    reportAskdViewCase,
    
    reportCsrView,
    reportCsrNote,
    reportCsrViewCase,
}
